module.exports = __webpack_public_path__ + "img/drop-teal.04f5d614.svg";